import { RootState } from "@/redux/store";

export const operatorBrandingSelector = (state: RootState) => state.brandingAndAcquisition.operatorBranding;
export const registrationSelector = (state: RootState) => state.brandingAndAcquisition.registration;
